import { useState } from 'react';

export default function useCheckoutMapTimer() {
  const [timeLeft, setTimeLeft] = useState(null);
  const [timeLeftString, setTimeLeftString] = useState(null);
  const [endDate, setEndDate] = useState(null);

  return {
    timeLeft,
    setTimeLeft,
    timeLeftString,
    setTimeLeftString,
    endDate,
    setEndDate,
  };
}
